/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { action } from 'typesafe-actions';
import { ModalContentProps } from '../../../layout/Master/styles';
import { UserAddresses, UserAddressShipping, UserCard } from '../auth/types';

import {
  MethodsProps,
  ParameterActionTypes,
  ParameterProps,
  Store,
  Locker,
  MethodsType,
} from './types';
import { ServicesProps } from '../product/types';
import { AddressSelectedProps } from '../../../hooks/useCheckoutInfo';

export function parameterClear() {
  return action(ParameterActionTypes.PARAMETER_CLEAR);
}

export function openMenu(data: ParameterProps) {
  return action(ParameterActionTypes.OPEN_MENU, {
    data,
  });
}

export function openMenuBase() {
  return action(ParameterActionTypes.OPEN_MENU_BASE);
}

export function openMenuAccount(menuId: number) {
  return action(ParameterActionTypes.OPEN_MENU_ACCOUNT, { menuId });
}

export function openMenuAccountClear() {
  return action(ParameterActionTypes.OPEN_MENU_ACCOUNT_CLEAR);
}

export function openShowModal(open?: boolean) {
  return action(ParameterActionTypes.OPEN_MODAL, { open });
}

export function viewCheckout(viewCheckout?: boolean) {
  return action(ParameterActionTypes.VIEW_CHECKOUT, { viewCheckout });
}

export function viewModal(
  content: React.ComponentType,
  props?: ModalContentProps,
  open?: boolean,
) {
  return action(ParameterActionTypes.VIEW_MODAL, { content, props, open });
}

export function setIsCategory(isCaregory: boolean) {
  return action(ParameterActionTypes.IS_CATEGORY, { isCaregory });
}

export function findMethods() {
  return action(ParameterActionTypes.FIND_METHODS);
}

export function findMethodsSuccess(methods: UserCard[]) {
  return action(ParameterActionTypes.FIND_METHODS_SUCCESS, { methods });
}

export function findMethodsAll() {
  return action(ParameterActionTypes.FIND_METHODS_ALL);
}

export function findMethodsAllSuccess(methods: MethodsProps[]) {
  return action(ParameterActionTypes.FIND_METHODS_ALL_SUCCESS, { methods });
}

export function findMethodsTypeSuccess(methods: MethodsType) {
  return action(ParameterActionTypes.FIND_METHODS_TYPE_SUCCESS, { methods });
}


export function findMethodById(method_id: number) {
  return action(ParameterActionTypes.FIND_METHOD_ID, { method_id, });
}

export function findMethodByIdSuccess(methods: UserCard[]) {
  return action(ParameterActionTypes.FIND_METHOD_ID_SUCCESS, { methods });
}

export function findMethodByIdFailure() {
  return action(ParameterActionTypes.FIND_METHOD_ID_FAILURE);
}

export function methodSelectedRequest(
  media_id: number,
  method_id: number,
) {
  return action(ParameterActionTypes.METHOD_SEL, {
    media_id,
    method_id,
  });
}

export function methodSetSelected(method: UserCard) {
  return action(ParameterActionTypes.METHOD_SET_SELECTED, { method });
}

export function methodSetSelectedClear() {
  return action(ParameterActionTypes.METHOD_CLEAR, { });
}


export function methodSelectedSuccess() {
  return action(ParameterActionTypes.METHOD_SEL_SUCCESS);
}

export function methodCreated(media: MethodsProps, card: UserCard) {
  return action(ParameterActionTypes.METHOD_CREATER, { media, card });
}

export function methodCreatedSuccess(card: UserCard[]) {
  return action(ParameterActionTypes.METHOD_CREATER_SUCCESS, { card });
}

export function findStoreAll() {
  return action(ParameterActionTypes.FIND_STORE_ALL);
}

export function findStoreAllSuccess(stores: Store[]) {
  return action(ParameterActionTypes.FIND_STORE_ALL_SUCCESS, { stores });
}

export function findStoreAllFailure() {
  return action(ParameterActionTypes.FIND_STORE_ALL_FAILURE);
}

export function findLockerAll() {
  return action(ParameterActionTypes.FIND_LOCKER_ALL, { });
}

export function findLockerAllSuccess(lockers: Locker[]) {
  return action(ParameterActionTypes.FIND_LOCKER_ALL_SUCCESS, { lockers });
}

export function storeSelectedRequest(store: Store) {
  return action(ParameterActionTypes.STORE_SEL, {
    store,
  });
}

export function lockerSelectedRequest(locker: Locker) {
  return action(ParameterActionTypes.LOCKER_SEL, {
    locker,
  });
}

export function btnNextCheckout() {
  return action(ParameterActionTypes.BTN_NEXT_CHECKOUT);
}

export function calculateShippingRatesSpecificRequest(
  payload
    : {
      selectedShippingOption: UserAddressShipping;
      postcode: string;
      number: string;
      addressId: number;
      setaddressSelect: ({ id, type }: AddressSelectedProps) => void
    }) {
  return action(ParameterActionTypes.CALCULATE_SHIPPING_RATE_SPECIFC, payload);
}

export function findShippingValue(
  method: string,
  address: UserAddresses,
  setaddressSelect: ({ id, type }: AddressSelectedProps) => void
) {
  return action(ParameterActionTypes.FIND_SHIPPING_VALUE, {
    method,
    address,
    setaddressSelect,
  });
}

export function findShippingValueSuccess(shippintRates: UserAddressShipping[]) {
  return action(ParameterActionTypes.FIND_SHIPPING_VALUE_SUCCESS, {
    shippintRates,
  });
}

export function selectShippingOption(shippingOption: UserAddressShipping) {
  return action(ParameterActionTypes.SELECT_SHIPPING_OPTION, {
    shippingOption,
  });
}

export function clearShippingOption() {
  return action(ParameterActionTypes.CLEAR_SHIPPING_OPTION);
}

export function calculateShippingRatesSpecificSuccess(shippingOption: UserAddressShipping) {
  return action(ParameterActionTypes.CALCULATE_SHIPPING_RATE_SPECIFC_SUCCESS, {
    shippingOption,
  });
}

export function setMessageToast(
  {
    type,
    message,
    messageTranslationId
  }: {
    type: 'success' | 'error' | 'warning',
    message?: string,
    messageTranslationId?: string,
  }
) {
  return action(ParameterActionTypes.SET_MESSAGE_TOAST, { 
    type, 
    message, 
    messageTranslationId 
  });
}

export function setMessageToastClear() {
  return action(ParameterActionTypes.SET_MESSAGE_TOAST_CLEAR);
}

export function methodFavorite(method_id: number) {
  return action(ParameterActionTypes.METHOD_FAVORITE, { method_id });
}

export function methodFavoriteSuccess(method: UserCard) {
  return action(ParameterActionTypes.METHOD_FAVORITE_SUCCESS, { method });
}

export function methodRemove(method_id: number) {
  return action(ParameterActionTypes.METHOD_REMOVE, { method_id });
}

export function methodRemoveSuccess() {
  return action(ParameterActionTypes.METHOD_REMOVE_SUCCESS);
}

export function addresssPostcodeRequest(postCode: string) {
  return action(ParameterActionTypes.ADDRESSES_FIND_POSTCODE_REQUEST, {
    postCode,
  });
}

export function addresssPostcodeSuccess(addresse: UserAddresses) {
  return action(ParameterActionTypes.ADDRESSES_FIND_POSTCODE_SUCCESS, {
    addresse,
  });
}

export function addresssPostcodeFailure() {
  return action(ParameterActionTypes.ADDRESSES_FIND_POSTCODE_FAILURE);
}

export function addresssAll() {
  return action(ParameterActionTypes.ADDRESSES_FIND_ALL_REQUEST);
}

export function addresssAllSuccess(addresses: UserAddresses[]) {
  return action(ParameterActionTypes.ADDRESSES_FIND_ALL_SUCCESS, { addresses });
}

export function addresssAllFailure() {
  return action(ParameterActionTypes.ADDRESSES_FIND_ALL_FAILURE);
}

export function addressesSelectedRequest(
  addresse: UserAddresses,
  bSendApi: boolean,
) {
  return action(ParameterActionTypes.ADDRESSES_SEL, { addresse, bSendApi });
}

export function addressesSelectedSuccess(addresse: UserAddresses) {
  return action(ParameterActionTypes.ADDRESSES_SEL_SUCCESS, { addresse });
}

export function addressesEditRequest(addresse: UserAddresses) {
  return action(ParameterActionTypes.ADDRESSES_EDIT_REQUEST, { addresse });
}

export function addressesCreatedOrUpdateRequest(addresse: UserAddresses) {
  return action(ParameterActionTypes.ADDRESSES_CREATED_UPDATE_REQUEST, {
    addresse,
  });
}

export function addressesCreatedOrUpdateSuccess() {
  return action(ParameterActionTypes.ADDRESSES_CREATED_UPDATE_SUCCESS);
}

export function addressesCreatedOrUpdateFailure() {
  return action(ParameterActionTypes.ADDRESSES_CREATED_UPDATE_FAILURE);
}

export function addressesRemoveRequest(addresse: UserAddresses) {
  return action(ParameterActionTypes.ADDRESSES_REMOVE_REQUEST, { addresse });
}

export function addressesRemoveSuccess() {
  return action(ParameterActionTypes.ADDRESSES_REMOVE_SUCCESS);
}

export function addressesRemoveFailure() {
  return action(ParameterActionTypes.ADDRESSES_REMOVE_FAILURE);
}

export function setServiceInfo(serviceInfo: ServicesProps) {
  return action(ParameterActionTypes.SET_SERVICE_INFO, { serviceInfo });
}

export function clearServiceInfo() {
  return action(ParameterActionTypes.CLEAR_SERVICE_INFO);
}

export function clearLoading() {
  return action(ParameterActionTypes.CLEAR_LOADING);
}

export function setPayOnDelivery() {
  return action(ParameterActionTypes.PAY_ON_DELIVERY);
}

export function setLanguage(language: string) {
  return action(ParameterActionTypes.SELECT_LANGUAGE, {language});
}

export function setMultistoreSelected(store: Store) {
  return action(ParameterActionTypes.SET_MULTISTORE_SELECTED, {store});
}

export function updateCoordinatesRequest({
  id,
  coordinates
}: {
  id: number,
  coordinates: {longitude: string, latitude: string}
}) {
  return action(ParameterActionTypes.UPDATE_COORDINATES_REQUEST, {coordinates, id});
}

export function updateCoordinatesSuccess() {
  return action(ParameterActionTypes.UPDATE_COORDINATES_SUCCESS);
}
